<div class="fixed top-5 right-5 z-50">
  <div *ngFor="let toast of (toastState$ | async)?.toasts" 
       [class]="'p-4 mb-2 rounded-md shadow-lg flex justify-between items-center ' + getToastClass(toast.type)">
    <span>{{ toast.message }}</span>
    <button *ngIf="toast.dismissible" (click)="closeToast(toast.id)" class="ml-4 text-lg font-semibold">&times;</button>
  </div>
</div>
